import React from 'react'
import style from './styles.module.css'
import Topheader from '../../components/Topheader'
export default function CoinDetailsNew() {
  return (
     <>
         <div>
            <Topheader colorbox="newfaq_header_color" title="Detalles de Fichas"/>
           <div className="top-container container">
             <img
               src={require("../../images/coins-detail/mainbanner.webp")}
               alt="main banner"
               className="img-fluid py-4"
             />
           </div>
           <div className="container">
             <div className="">
               <div className={style.sec2_text1}>
                 ¿Qué son las Fichas?
               </div>
               <div className={style.sec2_text2}>
                Las Fichas son una moneda que recibe un jugador cuando participa en un juego popular en el que el operador cobra una comisión por facilitar los servicios del juego. La tarifa de conveniencia cobrada en comisión o rake no se incluye en el cálculo de las fichas.
               </div>
             </div>
           </div>
            <div className={style.sec3}>
    <div className={style.sec2_text1}>
        ¿Cómo se generan las Fichas?
    </div>
    <div className={style.sec3_box}>
         <img
               src={require("../../images/coins-detail/step-2.png")}
               alt="main banner"
               className="img-fluid py-3"
               width={56}
             />
             <div className="">
                <div className={style.sec3_box_text1}>Paso 1: Juega un Juego Popular</div>
                 <div className={style.sec3_box_text2}>Toca el ícono en la pantalla de inicio para ver todas las recompensas disponibles.</div>
             </div>
    </div>
     <div className={style.sec3_box}>
         <img
               src={require("../../images/coins-detail/step-1.png")}
               alt="main banner"
               className="img-fluid py-3"
               width={56}

             />
             <div className="">
                <div className={style.sec3_box_text1}>Paso 2: Gana Fichas</div>
                 <div className={style.sec3_box_text2}>Gana fichas equivalentes al rake que generaste mientras jugabas la mano.</div>
             </div>
    </div>
   </div>
         </div>
       </>
  )
}
